import JSONApiClient from '../jsonapi-service';
import { authService } from '../auth-service';
import AxiosService from '../axios-service';

export function createDocument(documentData) {

  const client = JSONApiClient();

  const document = client.create('documents');

  document.set('name', documentData.name);
  document.set('filePath', documentData.filePath);
  document.set('docType', documentData.docType);
  document.set('fileType', documentData.fileType);
  document.set('size', documentData.size);
  document.set('discussion', { type: 'discussions', id: documentData.discussionId });
  if (documentData.message) { document.set('message', documentData.message); }
  if (documentData.version) { document.set('version', documentData.version); }
  document.set('approved', documentData.approved);

  return document.sync()
    .then(response => {
      // Returns a resource not a JSON object
      return response;
    });
}

export function getDocument(documentId) {

  const client = JSONApiClient();

  return client.get('documents', documentId, {})
    .then(response => {
      // Returns resource object
      return response;
    });
}

export function removeDocument(documentId) {

  const axiosService = new AxiosService(process.env.REACT_APP_API_BASE_URL, 10000, { Authorization: `Bearer ${authService.getToken()}`, });

  return axiosService.patch(`/documents/${documentId}`, {
    data: {
      id: documentId,
      type: 'documents',
      attributes: {
        removed: true,
        filePath: 'removed',
        approved: false,
      }
    }
  })
    .then((response) => {
      let documentData = response.data.data.attributes;
      documentData.id = response.data.data.id;
      // Returns JSON object
      return documentData;
    });
}

export function updateDocumentApproved(documentId, approvedData) {

  const axiosService = new AxiosService(process.env.REACT_APP_API_BASE_URL, 10000, { Authorization: `Bearer ${authService.getToken()}`, });

  const approved = approvedData.approved;
  const approvedBy = approvedData.approvedBy;
  const approvalDate = approvedData.approvalDate;

  return axiosService.patch(`/documents/${documentId}`, {
    data: {
      id: documentId,
      type: 'documents',
      attributes: {
        approved: approved,
        approvedBy: approvedBy,
        approvalDate: approvalDate,
      }
    }
  })
    .then((response) => {
      let documentData = response.data.data.attributes;
      documentData.id = response.data.data.id;
      // Returns JSON object
      return documentData;
    });
}



/** WEBPACK FOOTER **
 ** ./src/utils/jsonapi-functions/documents.js
 **/